import { render, staticRenderFns } from "./SupplierOnboardingCompleted.vue?vue&type=template&id=ecaea1ea&"
import script from "./SupplierOnboardingCompleted.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports